import { TStatus as TIssuedStatus } from "../mock";

export type TExportStatus = "Em processamento" | "Finalizada" | "Erro ao processar";

export type TNature =
  | "001 - Compra"
  | "002 - Venda"
  | "003 - Transferência"
  | "004 - Devolução"
  | "005 - Importação"
  | "006 - Exportação"
  | "007 - Remessa"
  | "008 - Retorno"
  | "009 - Outras entradas"
  | "010 - Outras saídas"
  | "011 - Serviços - ISSQN"
  | "012 - Lançamento de Crédito"
  | "013 - Recebimento"
  | "014 - Ressarcimento"
  | "015 - Serviço - ICMS";

export type TIssuedExportedInvoice = {
  start_date?: string;
  end_date?: string;
  status?: TIssuedStatus[];
  nature?: TNature[];
};

export const mockExportedInvoice: TIssuedExportedInvoice = {
  start_date: "2025-10-01",
  end_date: "2025-10-10",
  status: ["Autorizada", "Em processamento"],
  nature: ["002 - Venda", "001 - Compra"],
};

export const exportIssuedInvoicesMock = {
  count: 12,
  current_page: 1,
  pages: [{ "1": "" }],
  results: [
    {
      id: "001",
      start_date: "2025-09-01",
      end_date: "2025-09-30",
      created_at: "2025-10-01T08:00:00.000Z",
      created_by: "João da Silva",
      status: "Finalizada" as TExportStatus,
      uuid: "a1b2c3d4-e5f6-7890-ab12-cd34ef56ab78",
      xml_url: "https://example.com/xml/001",
      pdf_url: "https://example.com/pdf/001",
    },
    {
      id: "002",
      start_date: "2025-08-01",
      end_date: "2025-08-31",
      created_at: "2025-09-01T09:30:00.000Z",
      created_by: "Maria Oliveira",
      status: "Erro ao processar" as TExportStatus,
      uuid: "b2c3d4e5-f678-9012-ab34-cd56ef78ab90",
      xml_url: "https://example.com/xml/002",
      pdf_url: "",
    },
    {
      id: "003",
      start_date: "2025-07-01",
      end_date: "2025-07-31",
      created_at: "2025-08-01T10:15:00.000Z",
      created_by: "Carlos Souza",
      status: "Em processamento" as TExportStatus,
      uuid: "c3d4e5f6-7890-1234-ab56-cd78ef90ab12",
      xml_url: "",
      pdf_url: "https://example.com/pdf/003",
    },
  ],
};

export type TIssuedInvoicesExport = (typeof exportIssuedInvoicesMock.results)[0];
